import { render, staticRenderFns } from "./TableCellInterval.vue?vue&type=template&id=422bf251&"
import script from "./TableCellInterval.vue?vue&type=script&lang=ts&"
export * from "./TableCellInterval.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellInterval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports